module.exports = __webpack_public_path__ + "static/media/img-3.68f3f243.jpg";